const cards = [
  {
    title: '韩漫入门指南：从零开始的韩漫阅读之旅',
    desc: '刚接触韩国漫画不知道从哪里开始？这篇指南带你了解韩漫的分类、阅读习惯与推荐入坑作品。',
    image: 'https://readdy.ai/api/search-image?query=Beginner%20guide%20illustration%20with%20Korean%20manhwa%20books%20stacked%20on%20a%20desk%2C%20warm%20lighting%2C%20cozy%20reading%20atmosphere%2C%20cream%20and%20coral%20tones%2C%20educational%20editorial%20style%2C%20clean%20composition&width=800&height=500&seq=card-01&orientation=landscape',
    tag: '新手必读',
  },
  {
    title: '恋爱韩漫精选：20部让你心动的甜蜜佳作',
    desc: '从纯情校园到成熟职场，从青涩初恋到深情守护，20部精选恋爱韩漫带你感受不同层次的浪漫。',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20romance%20Korean%20manhwa%20covers%20arranged%20artistically%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20romantic%20atmosphere%2C%20editorial%20layout%2C%20delicate%20aesthetic%2C%20warm%20inviting%20mood&width=800&height=500&seq=card-02&orientation=landscape',
    tag: '恋爱精选',
  },
  {
    title: '韩漫阅读小技巧：提升你的阅读体验',
    desc: '掌握这些阅读技巧，让你的韩漫阅读更加流畅舒适，包括最佳阅读时段、屏幕设置建议等实用信息。',
    image: 'https://readdy.ai/api/search-image?query=Digital%20tablet%20displaying%20Korean%20manhwa%20with%20reading%20tips%20overlay%2C%20modern%20minimal%20setup%2C%20warm%20lighting%2C%20cream%20and%20terracotta%20tones%2C%20clean%20editorial%20photography&width=800&height=500&seq=card-03&orientation=landscape',
    tag: '阅读技巧',
  },
  {
    title: '完结韩漫推荐：一次性看过瘾的完结作品',
    desc: '不喜欢追更等待？这里整理了多部已完结的高分韩漫，完整故事线一次读完，满足你的阅读欲望。',
    image: 'https://readdy.ai/api/search-image?query=Complete%20collection%20of%20Korean%20manhwa%20volumes%20on%20a%20bookshelf%2C%20organized%20and%20colorful%2C%20warm%20ambient%20lighting%2C%20cream%20and%20coral%20tones%2C%20library%20aesthetic%2C%20editorial%20photography&width=800&height=500&seq=card-04&orientation=landscape',
    tag: '完结推荐',
  },
  {
    title: '冷门韩漫发掘：被低估的五部宝藏作品',
    desc: '避开热门喧嚣，探索那些不为人知但质量极高的冷门韩漫，每一部都是被埋没的宝藏。',
    image: 'https://readdy.ai/api/search-image?query=Hidden%20gem%20Korean%20manhwa%20illustration%20with%20mysterious%20glowing%20effect%2C%20dark%20cream%20and%20deep%20coral%20tones%2C%20intriguing%20atmosphere%2C%20artistic%20editorial%20style%2C%20clean%20focused%20composition&width=800&height=500&seq=card-05&orientation=landscape',
    tag: '宝藏挖掘',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑团队精心撰写的韩漫推荐文章，帮助你发现更多优质韩漫作品
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}